import React from 'react';
import Nav from './mainpage/nav';
import Console from './mainpage/console';

function Mainpage() {
    return (
        <>
            <Nav/>
            <Console/>
        </>
    )
}

export default Mainpage;